import { BrowserModule, Title } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import * as Material from "@angular/material";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  AppRoutingModule,
  routingComponents,
  entryComponents,
} from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HttpClientModule } from "@angular/common/http";
import { HttpModule } from "@angular/http";
import { FormDataService } from "./service/form/form-data.service";
import { WorkflowService } from "./service/workflow/workflow.service";
import { BehaviorModelChangeService } from "./service/behavior-model-change.service.service";
import { DialogService } from "./service/dialog-service";
import { CookieService } from "ngx-cookie-service";
import { ToastrModule } from "ngx-toastr";
import { CommonModule } from "@angular/common";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CookiesLocalService } from "./service/cookies-local.service";
import { PagerService } from "./service/pager.service";
import { DocumentUploadComponent } from "./document-upload/document-upload.component";
import { AddEditDocumentComponent } from "./document-upload/add-edit-document/add-edit-document.component";

@NgModule({
  declarations: [AppComponent, routingComponents],
  imports: [
    BrowserModule,
    CommonModule,
    Material.MatAutocompleteModule,
    Material.MatBadgeModule,
    Material.MatBottomSheetModule,
    Material.MatButtonModule,
    Material.MatButtonToggleModule,
    Material.MatCardModule,
    Material.MatCheckboxModule,
    Material.MatChipsModule,
    Material.MatStepperModule,
    Material.MatDatepickerModule,
    Material.MatDialogModule,
    Material.MatDividerModule,
    Material.MatExpansionModule,
    Material.MatGridListModule,
    Material.MatIconModule,
    Material.MatInputModule,
    Material.MatListModule,
    Material.MatMenuModule,
    Material.MatNativeDateModule,
    Material.MatPaginatorModule,
    Material.MatProgressBarModule,
    Material.MatProgressSpinnerModule,
    Material.MatRadioModule,
    Material.MatRippleModule,
    Material.MatSelectModule,
    Material.MatSidenavModule,
    Material.MatSliderModule,
    Material.MatSlideToggleModule,
    Material.MatSnackBarModule,
    Material.MatSortModule,
    Material.MatTableModule,
    Material.MatTabsModule,
    Material.MatToolbarModule,
    Material.MatTooltipModule,
    Material.MatTreeModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    // tslint:disable-next-line: deprecation
    HttpModule,
    ToastrModule.forRoot(),
  ],
  providers: [
    PagerService,
    Title,
    DialogService,
    CookieService,
    FormDataService,
    FormDataService,
    WorkflowService,
    WorkflowService,
    BehaviorModelChangeService,
    CookiesLocalService,
  ],
  bootstrap: [AppComponent],
  entryComponents: [entryComponents],
})
export class AppModule {}
